import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-admin-page-section',
  imports: [TranslateModule],
  template: `
    <section>
      <header>
        <h2>{{ titleT | translate }}</h2>
      </header>
      <ng-content></ng-content>
    </section>
  `,
  styleUrl: './admin-page-section.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class AdminPageSectionComponent {
  @Input({ required: true }) titleT: string;
}
